export default [
  {
    route: 'Home',
    theme: 'ThemeHome'
  },
  {
    route: 'Login',
    theme: 'ThemeHome'
  },
  {
    route: 'contact',
    theme: 'ThemeContacts'
  },
/*   {
    route: 'Evemts',
    theme: 'ThemeEvents'
  }, */
  {
    route: 'People',
    theme: 'ThemePeople'
  },
  {
    route: 'Recruitment',
    theme: 'ThemePeople'
  },
  {
    route: 'Cases',
    theme: 'ThemeCases'
  },
  {
    route: 'About',
    theme: 'ThemeHome'
  },
  {
    route: 'Solutions',
    theme: 'ThemeHome'
  },
  {
    route: 'Responsibility',
    theme: 'ThemeHome'
  },
  {
    route: 'InfoChatBot',
    theme: 'ThemeHome'
  },
  {
    route: 'CookiePolicy',
    theme: 'ThemeHome'
  },
  {
    route: 'PrivacyPolicy',
    theme: 'ThemeHome'
  },
  {
    route: 'TermsConditions',
    theme: 'ThemeHome'
  },
  {
    route: 'Recover',
    theme: 'ThemeHome'
  },
  {
    route: 'ResponsibilityView',
    theme: 'ThemeHome'
  },
  {
    route: 'Case',
    theme: 'ThemeCases'
  }
]
